import { openModal } from "./modal";

export function showRulesModal(): void {
  const content = document.createElement("div");
  content.innerHTML = `
    <h2 class="title-display">Regles</h2>
    <div class="modal-scroll rules-text">
      <p>Echecs classiques, a deux joueurs sur le meme appareil, tour par tour.</p>
      <h3>Deplacements</h3>
      <ul>
        <li>Pion : avance d'une case (deux depuis sa case de depart), capture en diagonale, prise en passant possible juste apres un double pas adverse.</li>
        <li>Cavalier : saute en "L", seule piece qui peut franchir d'autres pieces.</li>
        <li>Fou : se deplace en diagonale, sur une seule couleur de case toute la partie.</li>
        <li>Tour : se deplace en ligne droite (colonnes/rangees).</li>
        <li>Dame : combine tour et fou.</li>
        <li>Roi : une case dans toutes les directions ; peut roquer avec une tour si aucun des deux n'a bouge, les cases entre eux sont libres, et le roi n'est ni en echec ni ne traverse ni n'atterrit sur une case attaquee.</li>
      </ul>
      <h3>Fin de partie</h3>
      <ul>
        <li>Echec et mat : le roi est attaque et aucun coup ne peut lever la menace.</li>
        <li>Pat : le joueur au trait n'est pas en echec mais n'a aucun coup legal — partie nulle.</li>
        <li>Nulle par repetition triple, par la regle des 50 coups, ou par materiel insuffisant pour mater.</li>
      </ul>
    </div>
    <div class="menu-actions">
      <button class="btn" id="close-rules" type="button">Fermer</button>
    </div>
  `;
  const { close } = openModal(content);
  content.querySelector<HTMLButtonElement>("#close-rules")?.addEventListener("click", close);
}
